import { useMemo } from "react";

import { useMarketplaceContext } from "../contexts/marketplace_context";
import { getMatchingActivitiesFilters } from "../helpers/get_matching_activities_filters";
import { useStartDateFilter } from "./use_start_date_filter";

export const useUnreadActivitiesFilters = () => {
  const { filtersData } = useMarketplaceContext();
  const { startDateCondition } = useStartDateFilter();

  return useMemo(
    () => getMatchingActivitiesFilters(filtersData, true, startDateCondition),
    [filtersData, startDateCondition]
  );
};
